import { _axios } from '@/plugins/axios';
import { IProductInfo, IProductRequest } from '../../shared/models/products/index';

export default {
  async getListProduct(): Promise<IProductInfo[]> {
    try {
      const products = await _axios.get('/product');
      return products.data;
    } catch (e) {
      throw e;
    }
  },
  async getProduct(id: any): Promise<IProductInfo> {
    try {
      const product = await _axios.get(`/product/${id}`);
      return product.data;
    } catch (e) {
      throw e;
    }
  },
  async updateProduct(id: any, product: IProductRequest): Promise<void> {
    try {
      await _axios.put(`/manage/product/${id}`, product);
    } catch (e) {
      throw e;
    }
  },
  async createProduct(product: IProductRequest): Promise<void> {
    try {
      await _axios.post('/manage/product/', product);
    } catch (e) {
      throw e;
    }
  },
};
